'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

var omit = {};

exports.__exports = omit;
